var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpDefES(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "spDef_e_s",
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.004,
    height: 56.004,
    viewBox: "0 0 56.004 56.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON_Speaker_Error-Sel"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6955\\u5186\\u5F62_175",
    "data-name": "\\u6955\\u5186\\u5F62 175",
    transform: "translate(7.997 8.002)",
    fill: "#fff",
    stroke: "#5fc7bc",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 21.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_180",
    "data-name": "\\u6955\\u5186\\u5F62 180",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(11.997 12.002)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1497",
    "data-name": "\\u30D1\\u30B9 1497",
    d: "M0,0H56V56H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "error_black_24dp",
    transform: "translate(36)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_174",
    "data-name": "\\u6955\\u5186\\u5F62 174",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(2 2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cancel_FILL1_wght400_GRAD200_opsz48",
    d: "M9.57,18.055l3.63-3.63,3.63,3.63,1.226-1.226-3.63-3.63,3.63-3.63L16.829,8.344l-3.63,3.63L9.57,8.344,8.344,9.57l3.63,3.63-3.63,3.63ZM13.2,23.2a9.586,9.586,0,0,1-3.882-.793,10.138,10.138,0,0,1-5.324-5.336,9.9,9.9,0,0,1,0-7.764A10.2,10.2,0,0,1,6.145,6.12,10.035,10.035,0,0,1,9.329,3.981a10.036,10.036,0,0,1,7.764,0,9.955,9.955,0,0,1,5.324,5.324,9.859,9.859,0,0,1,.781,3.918,9.653,9.653,0,0,1-.781,3.858,10.071,10.071,0,0,1-2.139,3.173,10.2,10.2,0,0,1-3.185,2.151A9.671,9.671,0,0,1,13.2,23.2Z",
    transform: "translate(-3.2 -3.198)",
    fill: "#e8231e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ICON_Volume-3",
    transform: "translate(15.997 16.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1275",
    "data-name": "\\u30D1\\u30B9 1275",
    d: "M5.484,5.2H0V12.92H5.484l5.154,5.143V.06Z",
    transform: "translate(5 2.938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_2694",
    "data-name": "\\u9577\\u65B9\\u5F62 2694",
    width: 24,
    height: 24,
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_2695",
    "data-name": "\\u9577\\u65B9\\u5F62 2695",
    width: 20,
    height: 20,
    transform: "translate(2 2)",
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpDefES);
export default __webpack_public_path__ + "static/media/spDef_e_s.77f5be34872bd731d7b289d682e00cf7.svg";
export { ForwardRef as ReactComponent };